import React, { useEffect, useState, useRef } from 'react'
import { message, Tooltip } from 'antd'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

import { Tag, Text } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { ErrorAlert } from '../../Reusable/Alert'
import { Flex, FlexColumn } from '../../Reusable/Container'
import { Dropdown, Menu } from '../../Reusable/Dropdown'
import { apiPOSTReq } from '../../../Utils/api'

// Images
import { TextButton, ImageButton } from '../../Reusable/Button'
import environment from '../../../environment'
import { LoadingOutlined } from '@ant-design/icons'
import Lock from '../../../Images/lock-selected.svg'
import Unlock from "../../../Images/lock-primary.svg"
import LockLighter from "../../../Images/LockLighter.png"
import ArrowRight from "../../../Images/arrow-right.png"
import More from "../../../Images/more-circle.png"
import hexToRgba from 'hex-to-rgba'


const DebitCard = ({ ...props }) => {
    const [loading, setLoading] = useState(false)
    const [activateLoading, setActivateLoading] = useState(false)
    const [tooltipVisible, setTooltipVisible] = useState(true)
    const [dropdownVisible, setDropdownVisible] = useState()

    const isMounted = useRef(false); // Tracks whether the component has mounted

    const { onViewCard, debitCard, setDebitCard, setPin, view, activateCard } = props

    const { UserInfo } = props.aionStore

    const suspendCard = () => {
        setLoading(true)

        apiPOSTReq(`${environment.bbBaseUrl}/bb/card/suspendCard`, { "BankProvider": environment.bankProvider.crb }, { bbPersonCard: debitCard }, (err, resp) => {
            setLoading(true)
            try {
                const data = resp || {}
                if (data.result) {
                    console.log('suspendCard', data)
                    debitCard.status = 'Suspended'
                    setDebitCard(debitCard)
                    // onUpdateCard(debitCard)
                    message.success('Card locked!')
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/suspendCard err", error, resp)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            } finally {
                setLoading(false)
            }
        })
    }

    const unsuspendCard = () => {
        setLoading(true)

        apiPOSTReq(`${environment.bbBaseUrl}/bb/card/unsuspendCard`, { "BankProvider": environment.bankProvider.crb }, { bbPersonCard: debitCard }, (err, resp) => {
            setLoading(true)
            try {
                const data = resp || {}
                if (data.result) {
                    console.log('suspendCard', data)
                    debitCard.status = 'Active'
                    setDebitCard(debitCard)
                    // onUpdateCard(debitCard)
                    message.success('Card unlocked!')
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/unsuspendCard err", error, resp)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            } finally {
                setLoading(false)
            }
        })
    }

    return (
        <FlexColumn between className='debit-card-back' style={{ padding: '18px 22px' }}>
            <Flex fullWidth end gap='12px'>
                {
                    view &&
                    <Text color='white' margin='4px 0'>{debitCard.firstName} {debitCard.lastName}</Text>
                }

                {
                    (!view || UserInfo.Email === debitCard.emailAddress) && !loading && debitCard.status && debitCard.status !== 'Closed' && debitCard.orderStatus !== 'OrderPending' &&
                    <Dropdown
                        placement='bottomLeft'
                        visible={dropdownVisible}
                        trigger='click'
                        onVisibleChange={(visible) => setDropdownVisible(visible)}
                        overlay={
                            <Menu>
                                <FlexColumn gap='16px'>
                                    {debitCard.status !== 'Unactivated' && (
                                        <TextButton text='VIEW DETAILS' rightIcon={<Image src={ArrowRight} />} onClick={() => onViewCard()} />
                                    )}
                                    {debitCard.status !== 'Unactivated' && debitCard.status !== 'Closed' && (
                                        <TextButton text={debitCard.isPinSet === false ? "SET PIN" : "CHANGE PIN"} rightIcon={<Image src={ArrowRight} />} onClick={() => setPin()} />
                                    )}
                                    {debitCard.status === 'Active' && (
                                        <TextButton text='LOCK' rightIcon={<Image src={Lock} />} onClick={() => suspendCard()} />
                                    )}
                                    {debitCard.status === 'Suspended' && (
                                        <TextButton text='UNLOCK' rightIcon={<Image src={Unlock} />} onClick={() => unsuspendCard()} />
                                    )}
                                    {debitCard.status === 'Unactivated' && (
                                        <TextButton loading={activateLoading} text='ACTIVATE NOW' onClick={() => {
                                            setActivateLoading(true)
                                            activateCard()
                                        }} />
                                    )}
                                </FlexColumn>
                            </Menu>
                        }
                    >
                        <Tooltip
                            title={debitCard.status === 'Unactivated' ? 'Activate' : 'Card Info, Lock/Unlock, Update PIN'}
                            key="card-more"
                            visible={tooltipVisible}
                            defaultVisible={true}
                            onVisibleChange={(visible) => setTooltipVisible(visible)}
                            color={props.theme.colors.primary}
                            overlayClassName='parent-node-ant-tooltip'
                            overlayStyle={{ minWidth: debitCard.status !== 'Unactivated' && '150px' }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            placement='right'>
                            <ImageButton src={More} />
                        </Tooltip>
                    </Dropdown>
                }

                {
                    loading &&
                    <FlexColumn center style={{ width: 24, height: 24 }}>
                        <LoadingOutlined style={{ color: 'white' }} />
                    </FlexColumn>
                }
            </Flex>
            {
                <Flex between>
                    <Text size='20px' spacing='8px' color='white'>•••• {(debitCard.status !== 'Unactivated') ? debitCard.last4 : '••••'}</Text>

                    {
                        (!view || UserInfo.Email === debitCard.emailAddress) && !loading && debitCard.status && debitCard.status === 'Closed' &&
                        <TextButton text='View details' underline weight='400' onClick={() => onViewCard()} />
                    }
                </Flex>
            }

            <Flex start gap='8px'>
                <Tag background='#333333' color='#CCCCCC' height='32px'>{["VirualPan", "VirtualPan"].includes(debitCard.paymentInstrument) ? 'Virtual' : 'Physical'}</Tag>
                {
                    debitCard && (() => {
                        switch (debitCard.status) {
                            case 'Closed':
                                return <Tag background='#333333' color='#CCCCCC' height='32px'>Closed</Tag>
                            case 'Suspended':
                                return <Tag background='#333333' color='#CCCCCC' height='32px'><Image margin='0 4px 0 0' src={LockLighter} />Locked</Tag>
                            case 'Unactivated':
                                switch (debitCard.orderStatus) {
                                    case 'OrderPending':
                                        return <Text title='New virtual cards can take a few minutes to complete processing' color={hexToRgba(props.theme.colors.primary8, 1)} height='32px' weight={600}>Processing</Text>
                                    case 'Completed':
                                        return null //<Tag background='#333333' color='#CCCCCC'>**/**</Tag>
                                    default:
                                        return null // <Tag background='#333333' color='#CCCCCC'>{moment(debitCard.expirationDate).format("MM/YY")}</Tag>
                                }
                            default:
                                return null // <Tag background='#333333' color='#CCCCCC'>{moment(debitCard.expirationDate).format("MM/YY")}</Tag>
                        }
                    })()
                }
            </Flex>
        </FlexColumn>
    )
}


function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(DebitCard)))